import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Jpg"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 17.25H18C17.1716 17.25 16.5 16.5784 16.5 15.75V8.25C16.5 7.42157 17.1716 6.75 18 6.75H22.5V8.25H18V15.75H21V12.75H19.5V11.25H22.5V17.25ZM10.5 17.25H9V6.75H13.5C14.3284 6.75 15 7.42157 15 8.25V12C15 12.8284 14.3284 13.5 13.5 13.5H10.5V17.25ZM10.5 12H13.5V8.25H10.5V12ZM6 17.25H3C2.17157 17.25 1.5 16.5784 1.5 15.75V14.25H3V15.75H6V6.75H7.5V15.75C7.5 16.5784 6.82843 17.25 6 17.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Jpg.vue"]]);
